import React, { useState, useEffect } from "react";

const Block = () => {
    const [blocks, setBlocks] = useState([]);

    const SERVER_API = "https://bell-project-backend.fly.dev"
    

    useEffect(() => {
        const fetchBlocks = async () => {
            try {
                const response = await fetch(`${SERVER_API}/blogs/block`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({})
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const data = await response.json();
                setBlocks(data); // Зберігаємо масив блоків у стані
            } catch (error) {
                console.error("Помилка при отриманні даних:", error);
            }
        };

        fetchBlocks();
    }, []); // Викликаємо один раз при завантаженні сторінки

    if (window.innerWidth < 600) {
            return (
                <div className="blog_section_div">
                    {blocks.map((block) => (
                        <section key={block.numer_id} className="blog_section">
                            <img src={block.image} alt="blog" className="blog_picture" />
                            <div>
                                <h2>{block.header}</h2>
                                <p>{block.paragraf}</p>
                            </div>
                        </section>
                    ))}
                </div>
            );
    }
    return (
        <div className="blog_section_div">
            {blocks.map((block) => (
                <section key={block.numer_id} className="blog_section">
                    <div>
                        <h2>{block.header}</h2>
                        <p>{block.paragraf}</p>
                    </div>
                    <img src={block.image} alt="blog" className="blog_picture" />
                </section>
            ))}
        </div>
    );
};

export default Block;

